import React from "react";
import { ReportsCell, ReportsCellWrapper } from "./Grid.styles";
import { CellRendererProps } from "./types";

export const ReportColumnCell: React.FC<CellRendererProps> = ({ data }) => {
  const getCompleted = () => {
    if (!data.reportSummary) return false;
    const completedVals = data.reportSummary
      .split("of")
      .map((val) => Number(val.trim()));

    return completedVals[0] / completedVals[1] === 1;
  };

  return (
    <ReportsCellWrapper>
      <ReportsCell completed={getCompleted()}>
        {data.reportSummary || ""}
      </ReportsCell>
    </ReportsCellWrapper>
  );
};
